import React, { useState, useEffect, useCallback, useContext } from 'react';
import { TenantContext } from '../../tenant/TenantContext';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { CancelButton } from 'uiwidgets/CancelButton';
import { NewButton as AppButton } from './../../uiwidgets/NewButton';
import { Row, Col, Card, Table, Button, Modal } from 'react-bootstrap';
import { API } from '../../api/API';
import { BUSINESS_PROMOTIONS, BUSINESS_DONATION_CAUSES_URL } from '../../config/config';
import { extractError } from '../../api/ErrorUtil';
import {
    isNumeric, containsAlphaNumOnly,
    containsAlphaNumAndSpaceAndPunctuationOnly, isValidDate,
    isDateGreaterThanOrEqualToToday, isFirstDateLesserThanSecondDate
} from 'util/Validators';
import _ from "lodash";
import { evenRound } from 'util/NumberUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FilesField } from 'uiwidgets/FilesField';
import { useParams, useNavigate } from 'react-router-dom';



const BusinessPromotion = () => {
    const initialState = {
        errors: {},
        infoMessage: "",
        promotionId: null,
        name: "",
        description: "",
        startDate: "",
        endDate: "",
        donationAmountTrigger: "0.00",
        promotionOptions: [],
        promotionImages: [],
        donationCauses: [],
        readOnly: false,
        editMode: false,
        randImageId: Date.now()
    }
    const initialValidationState = {
        nameError: false,
        nameErrMsg: "",
        descriptionError: false,
        descriptionErrMsg: "",
        startDateError: false,
        startDateErrMsg: "",
        endDateError: false,
        endDateErrMsg: "",
        donationAmountTriggerError: false,
        donationAmountTriggerErrMsg: "",
        promotionOptions: [],
        promotionImages: [],
        donationCauses: [],
        isFormValid: true

    }

    const { businessConfig } = useContext(TenantContext);
    let [formData, setFormData] = useState(initialState);
    let [formValidityData, setFormValidityData] = useState(initialValidationState);
    let [promotion, setPromotion] = useState({});
    let [formTitle, setFormTitle] = useState("New Promotion");
    const [donationCauses, setDonationCauses] = useState([]);
    const requestParams = useParams();
    const navigate = useNavigate();

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const fetchDonationCauses = useCallback(async () => {
        try {
            let dc = await API.get(BUSINESS_DONATION_CAUSES_URL);
            let donationCauseList = dc.data
            setDonationCauses(donationCauseList);
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setDonationCauses([]);
                setFormData({ ...formData, infoMessage: "No donation causes were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    })

    useEffect(() => {
        fetchDonationCauses();
    }, []);

    const processImages = async (promotion) => {
        if (_.isEmpty(promotion.promotionImages)){
            return;
        }
        for (let promotionImage of promotion.promotionImages) {
            let imgSrcApiUrl = BUSINESS_PROMOTIONS + '/' + promotion.promotionId + '/img/' + promotionImage.id + '?img=' + Math.random();
            let imageResponse = await API.get(imgSrcApiUrl, { responseType: 'blob' });
            const file = new File([imageResponse.data], "img" + Math.random(), { type: promotionImage.mediaType });
            promotionImage.image = file;
            const imageUrl = URL.createObjectURL(file);
            promotionImage.imageSrc = imageUrl;
            
        }
    }


    const fetchPromotions = useCallback(async () => {
        try {

            if (requestParams.promotionId && requestParams.promotionId !== 'newpromotion') {
                let promotionResponse = await API.get(BUSINESS_PROMOTIONS + "/" + requestParams.promotionId);
                let promotion = promotionResponse.data
                await processImages(promotion);
                promotion.donationAmountTrigger = evenRound(Number(promotion.donationAmountTrigger)/100,2);
                setPromotion(promotion);

                setFormData({
                    ...promotion
                })
                setFormTitle("Modify Promotion");

                //initialize donation causes form validity data
                let numDonCauses = promotion.donationCauses.length;
                let initialDonCauseValObj = { donationCauseError: false, donationCauseErrMsg: "" };
                initialValidationState.donationCauses = Array.from({ length: numDonCauses }, () => ({ ...initialDonCauseValObj }));

                //initialze promotion options validity data
                let numPromoOptions = promotion.promotionOptions.length;
                let initialPromoOptValObj = { optionNameError: false, optionNameErrMsg: "", valError: false, valErrMsg: "" };
                initialValidationState.promotionOptions = Array.from({ length: numPromoOptions }, () => ({ ...initialPromoOptValObj }));

                //initialze promotion options validity data
                let numPromoImages = promotion.promotionImages.length;
                let initialPromoImagesValObj = { imageNameError: false, imageNameErrMsg: "" };
                initialValidationState.promotionImages = Array.from({ length: numPromoImages }, () => ({ ...initialPromoImagesValObj }));


            }
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setPromotion({});
                setFormData({ ...formData, infoMessage: "No promotions were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    })

    useEffect(() => {
        fetchPromotions();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const isFormValid = validateFullForm(event);
        //first check if there are validation errors
        if (!isFormValid) {
            alert("Form has validation errors");
            return false;
        }

        //submit form data here
        const postData = new FormData();
        const model = {
            id: formData.promotionId,
            name: formData.name,
            description: formData.description,
            startDate: formData.startDate,
            endDate: formData.endDate,
            donationAmountTrigger: Number(formData.donationAmountTrigger) * 100,
            promotionOptions: formData.promotionOptions,
            donationCauses: formData.donationCauses,
            promotionImages: formData.promotionImages.map(item => item.imageName)
        }
        for (let promoImg of formData.promotionImages) {
            postData.append('promotionImages', promoImg.image);
        }
        postData.append('promotion', JSON.stringify(model));
        let promotionUpdateResponse = null;
        
        try {
            if (requestParams.promotionId && requestParams.promotionId !== 'newpromotion') {
                promotionUpdateResponse = await API.put(BUSINESS_PROMOTIONS + "/" + requestParams.promotionId, postData);
            } else {
                promotionUpdateResponse = await API.post(BUSINESS_PROMOTIONS, postData);
            }
            //this is to refresh the image id so that it is no cached
            setFormData({
                ...formData,
                readOnly: true,
                infoMessage: "Promotion saved successfully",
                randImageId: Date.now()
            });
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError
            })
        }


    }

    const handleCancel = async (event) => {
        navigate("/businesspromotions");
    }


    const handleChange = async (event, idx) => {
        const name = event.target.name;
        const value = event.target.value;
        let state = { ...formData };
        if (idx === undefined) {
            state[name] = value;

        } else {
            if (name === 'optionName') {
                state.promotionOptions[idx].optionName = value
            } else if (name === 'value') {
                state.promotionOptions[idx].value = value
            } else if (name === 'imageName') {
                state.promotionImages[idx].imageName = value
            } else if (name === 'donationCauseCode') {
                state.donationCauses[idx].donationCauseCode = value
            } else if (name === 'image') {
                const file = event.target.files[0]
                state.promotionImages[idx].image = file
                if (file) {
                    state.promotionImages[idx].imageSrc = URL.createObjectURL(file);
                }
            }
        }

        setFormData({
            ...state
        });
    }

    const handleValidation = async (event, idx) => {
        const name = event.target.name;
        let value = event.target.value;
        if (name === 'image') {
            //value = event.target.files[0];
            //if (!value && requestParams.promotionId !== 'newpromotion'){
            value = formData.promotionImages[idx].image;
            if (value?.size){
                console.log("Image size:"+value.size);
            }
            //}
        }
        let { hasError, error } = validateInput(name, value);
        let state = { ...formValidityData };
        if (idx === undefined) {
            state[name + 'Error'] = hasError;
            state[name + 'ErrMsg'] = error;
        } else {
            if (name === 'optionName') {
                state.promotionOptions[idx].optionNameError = hasError;
                state.promotionOptions[idx].optionNameErrMsg = error;
            } else if (name === 'value') {
                state.promotionOptions[idx].valueError = hasError;
                state.promotionOptions[idx].valueErrMsg = error;
            } else if (name === 'imageName') {
                state.promotionImages[idx].imageNameError = hasError;
                state.promotionImages[idx].imageNameErrMsg = error;
            } else if (name === 'donationCauseCode') {
                state.donationCauses[idx].donationCauseCodeError = hasError;
                state.donationCauses[idx].donationCauseCodeErrMsg = error;
            } else if (name === 'image') {
                state.promotionImages[idx].imageError = hasError;
                state.promotionImages[idx].imageErrMsg = error;
            }
        }

        setFormValidityData({
            ...state
        });
    }

    const validateFullForm = (event) => {
        let state = { ...formValidityData };
        let isFormValid = true;
        let optionNameIdx = 0;
        let optionValueIdx = 0;
        let donationCauseIdx = 0;
        let imageIdx = 0;
        let imageNameIdx = 0;

        for (let i = 0; i < event.target.getElementsByTagName('input').length; i++) {
            let fieldName = event.target.getElementsByTagName('input')[i].name;
            let fieldValue = event.target.getElementsByTagName('input')[i].value;

            if (fieldName === 'image') {
                //fieldValue = event.target.getElementsByTagName('input')[i].files[0];
                //if (!fieldValue && requestParams.promotionId !== 'newpromotion'){
                    fieldValue = formData.promotionImages[imageIdx].image
                //}
            }
            const { hasError, error } = validateInput(fieldName, fieldValue);

            if (fieldName === 'optionName') {
                state.promotionOptions[optionNameIdx].optionNameError = hasError;
                state.promotionOptions[optionNameIdx].optionNameErrMsg = error;
                optionNameIdx++;
            } else if (fieldName === 'value') {
                state.promotionOptions[optionValueIdx].valueError = hasError;
                state.promotionOptions[optionValueIdx].valueErrMsg = error;
                optionValueIdx++;
            } else if (fieldName === 'imageName') {
                state.promotionImages[imageNameIdx].imageNameError = hasError;
                state.promotionImages[imageNameIdx].imageNameErrMsg = error;
                imageNameIdx++;

            } else if (fieldName === 'donationCauseCode') {
                state.donationCauses[donationCauseIdx].donationCauseCodeError = hasError;
                state.donationCauses[donationCauseIdx].donationCauseCodeErrMsg = error;
                donationCauseIdx++;
            } else if (fieldName === 'image') {
                state.promotionImages[imageIdx].imageError = hasError;
                state.promotionImages[imageIdx].imageErrMsg = error;
                imageIdx++;
            } else {
                state[fieldName + 'Error'] = hasError;
                state[fieldName + 'ErrMsg'] = error;
            }
            if (hasError) {
                isFormValid = false;
            }


        }

        for (let i = 0; i < event.target.getElementsByTagName('select').length; i++) {
            let fieldName = event.target.getElementsByTagName('select')[i].name;
            let fieldValue = event.target.getElementsByTagName('select')[i].value;
            const { hasError, error } = validateInput(fieldName, fieldValue);
            if (fieldName === 'donationCauseCode') {
                state.donationCauses[donationCauseIdx].donationCauseCodeError = hasError;
                state.donationCauses[donationCauseIdx].donationCauseCodeErrMsg = error;
                donationCauseIdx++;
            } else {
                state[fieldName + 'Error'] = hasError;
                state[fieldName + 'ErrMsg'] = error;
            }
            if (hasError) {
                isFormValid = false;
            }

        }

        setFormValidityData({
            ...state
        });
        return isFormValid;

    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "name":
                if (value.trim() === "") {
                    hasError = true
                    error = "Name cannot be empty"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true
                    error = "Name can only have alpha-numeric characters"
                } else if (value.length < 5) {
                    hasError = true
                    error = "Name  must be greater than 5 characters"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;

            case "description":
                if (value.trim() === "") {
                    hasError = false
                    error = ""
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Description can only have alpha-numeric characters"
                } else if (value.length < 5) {
                    hasError = true
                    error = "Description  must be greater than 5 characters"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "startDate":
                if (value.trim() === "" || !isValidDate(value)) {
                    hasError = true;
                    error = "Start date cannot be empty";
                } else if (!_.isEmpty(formData.endDate) && !isFirstDateLesserThanSecondDate(value, formData.endDate)) {
                    hasError = true;
                    error = "Start date must less than end date";
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            case "endDate":
                if (value.trim() === "" || !isValidDate(value)) {
                    hasError = true;
                    error = "End date is invalid";
                } else if (!isDateGreaterThanOrEqualToToday(value)) {
                    hasError = true;
                    error = "End date must be equal to or greater than today";
                } else if (!_.isEmpty(formData.endDate) && !isFirstDateLesserThanSecondDate(formData.startDate, value)) {
                    hasError = true;
                    error = "Start date must less than end date";
                } else {
                    hasError = false;
                    error = "";
                }
                break;

            case "donationCauseCode":
                if (value.trim() === "") {
                    hasError = true
                    error = "Donation cause code cannot be empty"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true
                    error = "Donation cause code can only have alpha-numeric characters"
                } else if (value.length < 5) {
                    hasError = true
                    error = "Donation cause code must be greater than 5 characters"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;
            case "donationAmountTrigger":
                {
                    if (value === "") {
                        hasError = true;
                        error = "Trigger amount cannot be empty";
                    } else if (!isNumeric(value)) {
                        hasError = true;
                        error = "Please enter a valid trigger amount";
                    } else if (isNumeric(value) && value <= 0) { 
                        hasError = true;
                        error = "Please enter a trigger amount greater than zero";
                    } else {
                        hasError = false;
                        error = "";
                    }
                    break;
                }

            case "optionName":
                if (value.trim() === "") {
                    hasError = true
                    error = "Option Name cannot be empty"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true
                    error = "Option Name can only have alpha-numeric characters"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;

            case "value":
                if (value.trim() === "") {
                    hasError = true
                    error = "Option Value cannot be empty"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true
                    error = "Option Value can only have alpha-numeric characters"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;

            case "imageName":
                if (value.trim() === "") {
                    hasError = true
                    error = "Image Name cannot be empty"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true
                    error = "Image Name can only have alpha-numeric characters"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;
            case "image":
                if (!value) {
                    hasError = true;
                    error = "Image is required";
                } else if (value?.size && value.size > 100 * 1024) {
                    hasError = true;
                    error = "Image cannot be larger than 100 kilo bytes";
                }
                break;
            default:
                break;
        }
        return { hasError, error };
    }


    const addNewDonationCause = async (event) => {
        let state = { ...formData };
        let valState = { ...formValidityData };
        state.donationCauses.push({
            "id": "",
            "active": null,
            "donationCauseCode": ""
        });
        valState.donationCauses.push({ donationCauseError: false, donationCauseErrMsg: "" });
        setFormData(state);
        setFormValidityData(valState);

    }

    const removeDonationCause = async (event, idx) => {
        let updatedDonCauses = formData.donationCauses.filter((item, i) => i !== idx);
        let updatedDonCausesVals = formValidityData.donationCauses.filter((item, i) => i !== idx);
        setFormData({
            ...formData,
            donationCauses: updatedDonCauses
        });
        setFormValidityData({
            ...formValidityData,
            donationCauses: updatedDonCausesVals
        });
    }

    const addNewPromotionImage = async (event) => {
        let state = { ...formData };
        let valState = { ...formValidityData };
        state.promotionImages.push({
            "id": "",
            "imageName": "",
            "image": null,
            "mediaType": ""

        });
        valState.promotionImages.push({ imageNameError: false, imageNameErrMsg: "" });
        setFormData(state);
    }

    const removePromotionImage = async (event, idx) => {
        let updatedImages = formData.promotionImages.filter((item, i) => i !== idx);
        let updatedImagesVals = formValidityData.promotionImages.filter((item, i) => i !== idx);
        setFormData({
            ...formData,
            promotionImages: updatedImages
        });
        setFormValidityData({
            ...formValidityData,
            promotionImages: updatedImagesVals
        });
    }

    const addNewPromotionOption = async (event) => {
        let state = { ...formData };
        let valState = { ...formValidityData };
        state.promotionOptions.push({
            "id": "",
            "optionName": "",
            "value": ""
        });
        valState.promotionOptions.push({ optionNameError: false, optionNameErrMsg: "", valError: false, valErrMsg: "" });
        setFormData(state);
        setFormValidityData(valState);
    }

    const removePromotionOption = async (event, idx) => {
        let updatedPromotionOptions = formData.promotionOptions.filter((item, i) => i !== idx);
        let updatedPromotionOptionsVals = formValidityData.promotionOptions.filter((item, i) => i !== idx);
        setFormData({
            ...formData,
            promotionOptions: updatedPromotionOptions
        });
        setFormValidityData({
            ...formValidityData,
            promotionOptions: updatedPromotionOptionsVals
        });

    }


    return (
        <FormContainer title={formTitle} submitButtonFunction={handleSubmit}
            errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>

            <Row>
                <Col mb={4} lg={4} sm={12}>
                    <FormField name="name" label="Promotion Name" type="text" value={formData.name}
                        placeholder="Enter Promotion Name" onChange={event => handleChange(event)} onBlur={event => handleValidation(event)}
                        valstate={!formValidityData.nameError} valMsg={formValidityData.nameErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col mb={8} lg={8} sm={12}>
                    <FormField name="description" label="Promotion Description" type="text" value={formData.description}
                        placeholder="Promotion description" onChange={handleChange} onBlur={event => handleValidation(event)}
                        valstate={!formValidityData.descriptionError} valMsg={formValidityData.descriptionErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormField
                        name="startDate"
                        label="Promotion Start Date"
                        type="date"
                        readOnly={formData.readOnly}
                        value={formData.startDate}
                        placeholder="Enter Promotion Start Date"
                        onChange={event => handleChange(event)}
                        onBlur={event => handleValidation(event)}
                        valstate={!formValidityData.startDateError} valMsg={formValidityData.startDateErrMsg} />
                </Col>
                <Col>
                    <FormField
                        name="endDate"
                        label="Promotion End Date"
                        type="date"
                        readOnly={formData.readOnly}
                        value={formData.endDate}
                        placeholder="Enter Promotion End Date"
                        onChange={event => handleChange(event)}
                        onBlur={event => handleValidation(event)}
                        valstate={!formValidityData.endDateError} valMsg={formValidityData.endDateErrMsg} />
                </Col>
                <Col>
                    <FormField
                        name="donationAmountTrigger"
                        label="Trigger Amount"
                        type="text"
                        value={formData.donationAmountTrigger}
                        placeholder="Enter Amount that triggers donation"
                        onChange={event => handleChange(event)}
                        onBlur={event => handleValidation(event)}
                        readOnly={formData.readOnly}
                        valstate={!formValidityData.donationAmountTriggerError}
                        valMsg={formValidityData.donationAmountTriggerErrMsg} />
                </Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    Donation Cause Trigger
                    <Button variant="dark" disabled={formData.readOnly} className="border-0 text-dark" onClick={evt => addNewDonationCause(evt)}>
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>
                </Col>
            </Row>
            {
                //promotion casues

                !_.isEmpty(formData.donationCauses) && formData.donationCauses.map(
                    (promotionCause, idx) => (
                        <Row key={idx}>
                            <Col sm={6} md={4} lg={4}>
                                <FormField name="donationCauseCode"
                                    type="select"
                                    readOnly={formData.readOnly}
                                    onChange={event => handleChange(event, idx)}
                                    onBlur={event => handleValidation(event, idx)}
                                    value={promotionCause.donationCauseCode}
                                    valstate={!formValidityData.donationCauses[idx].donationCauseCodeError}
                                    valMsg={formValidityData.donationCauses[idx].donationCauseCodeErrMsg}>
                                    <option value="" key="zeroval"></option>
                                    {donationCauses.map((donationCause, idx) => (
                                        <option value={donationCause.donationCauseCode} key={idx}>{donationCause.donationCauseDescription}</option>
                                    ))}
                                </FormField>
                            </Col>
                            <Col>
                                <Button variant="dark" disabled={formData.readOnly} className="border-0 text-dark" onClick={evt => removeDonationCause(evt, idx)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </Col>
                        </Row>
                    )
                )

            }
            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    Option Name

                </Col>
                <Col>
                    Option Value
                    <Button variant="dark" disabled={formData.readOnly} className="border-0 text-dark" onClick={evt => addNewPromotionOption(evt)}>
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>
                </Col>
            </Row>
            {
                //promotion Options
                !_.isEmpty(formData.promotionOptions) && formData.promotionOptions.map(
                    (promotionOption, idx) => (
                        <Row key={idx}>
                            <Col>
                                <FormField name="optionName"
                                    label="Option Name"
                                    type="text"
                                    value={promotionOption.optionName}
                                    placeholder="Enter Option Name"
                                    onChange={event => handleChange(event, idx)}
                                    onBlur={event => handleValidation(event, idx)}
                                    readOnly={formData.readOnly}
                                    valstate={!formValidityData.promotionOptions[idx].optionNameError}
                                    valMsg={formValidityData.promotionOptions[idx].optionNameErrMsg} />

                            </Col>
                            <Col>
                                <FormField name="value"
                                    label="Option Value"
                                    type="text"
                                    value={promotionOption.value}
                                    placeholder="Enter Option Value"
                                    onChange={event => handleChange(event, idx)}
                                    onBlur={event => handleValidation(event, idx)}
                                    readOnly={formData.readOnly}
                                    valstate={!formValidityData.promotionOptions[idx].valueError}
                                    valMsg={formValidityData.promotionOptions[idx].valueErrMsg} />
                            </Col>
                            <Col>
                                <Button variant="dark" disabled={formData.readOnly} className="border-0 text-dark" onClick={evt => removePromotionOption(evt, idx)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </Col>
                        </Row>

                    )
                )
            }
            <Row><Col>&nbsp;</Col></Row>

            <Row>
                <Col>
                    Image
                    <Button variant="dark" disabled={formData.readOnly} className="border-0 text-dark" onClick={evt => addNewPromotionImage(evt)}>
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>

                </Col>
            </Row>
            {
                //promotion casues
                !_.isEmpty(formData.promotionImages) && formData.promotionImages.map(
                    (promotionImage, idx) => (
                        <React.Fragment key={idx}>
                            <Row key={idx}>
                                <Col>
                                    {/*!promotionImage.imageSrc && promotionImage.mediaType && <Card.Img src={process.env.REACT_APP_BASE_API_URL + BUSINESS_PROMOTIONS
                                        + '/' + promotion.promotionId + '/img/' + promotionImage.id + '?i=' + formData.randImageId}
                                        style={{ height: '250px', width: '200px', objectFit: 'cover' }} />*/}
                                    {/*!promotionImage.imageSrc && !promotionImage.mediaType && <Card.Img src="/ui/images/no-image.svg"
                                        style={{ height: '250px', width: '200px', objectFit: 'cover' }} />*/}

                                    {promotionImage.imageSrc && <Card.Img src={promotionImage.imageSrc} alt="Selected" style={{ width: '200px', height: '250px' }} />}

                                    <FilesField name="image"
                                        label="Image"
                                        placeholder="Image"
                                        accept="image/*"
                                        readOnly={formData.readOnly}
                                        value={promotionImage.image}
                                        onChange={event => handleChange(event, idx)}
                                        onBlur={event => handleValidation(event, idx)}
                                        valstate={!formValidityData.promotionImages[idx].imageError}
                                        valMsg={formValidityData.promotionImages[idx].imageErrMsg} />

                                    <FormField name="imageName"
                                        label="Image Name"
                                        type="text"
                                        value={promotionImage.imageName}
                                        placeholder="Enter Image Name"
                                        onChange={event => handleChange(event, idx)}
                                        onBlur={event => handleValidation(event, idx)}
                                        readOnly={formData.readOnly}
                                        valstate={!formValidityData.promotionImages[idx].imageNameError}
                                        valMsg={formValidityData.promotionImages[idx].imageNameErrMsg} />
                                </Col>
                                <Col>
                                    <Button variant="dark" disabled={formData.readOnly} className="border-0 text-dark" onClick={evt => removePromotionImage(evt, idx)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Button>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                        </React.Fragment>

                    )
                )

            }
            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <SubmitButton label='Save Promotion' disabled={formData.readOnly} className="me-4" />
                    {!formData.readOnly && <CancelButton label='Cancel' onClick={handleCancel} />}
                    {formData.readOnly && <AppButton label='Return to Promotions List Page' onClick={(event) => navigate("/businesspromotions")} />}
                </Col>
            </Row>
        </FormContainer>
    )
}

export default BusinessPromotion